module.exports = __webpack_public_path__ + "img/kraemer.6449d867.png";